import store from '@/store'

function getTinaElement() {
  // Tina组件在body下面的第一层
  const elements = document.querySelectorAll('body > div')
  if (elements.length === 0) return null

  let tina = null
  const innerHTML = getLang() === 'zh' ? 'Tina | 传音智库' : ' Tina | TranAI'

  for (let i = 0; i < elements.length; i++) {
    const element = elements[i]

    //
    for (let j = 0; j < element.children.length; j++) {
      const child = element.children[j]
      if (child.innerHTML.includes(innerHTML)) {
        tina = element
        break
      }
    }
  }

  return tina
}

function initTinaSdk(config = {}) {
  if (window.transsionerTinaInit) {
    const initConfig = {
      businessCode: 'd66839b6d92245f4b4e791fc813c0817', // 必填，知识库页面配置的业务code
      token: '', // 必填
      rtoken: '', // 必填
      lang: 'zh', // 非必填 默认中文 en zh
      employeeNo: '', // 必填 工号
      terminal: 'pc', // 非必填，默认pc端，目前只支持pc端
      icon: '', // 非必填 icon图标
      radius: 40, // 非必填，tina图标显示大小（半径）默认40px
      width: 500, // 非必填，展开窗口宽度，默认500px
      height: 700, // 非必填，展开窗口高度，默认700px
      top: null, // 非必填，显示位置距离上边距离，默认null
      right: 30, // 非必填，显示位置距离右边距离，默认30px
      bottom: 60, // 非必填, 显示位置距离底部距离，默认40px
      left: null, // 非必填，显示位置距离左边距离，默认null
      clickoutside: false, // 非必填，点击窗口外部是否缩小窗口，默认false
      moveable: true, // 非必填 是否可拖动iframe窗口 默认为true
      onSSEStart: (message) => {
        console.log('js-sdk sse start', message)
      },
      onSSEEnd: (message) => {
        console.log('js-sdk sse end', message)
      },
    }
    window.transsionerTinaInit({
      ...initConfig,
      ...config,
    })

    console.log('window.transsionerTinaInit', window.transsionerTina)
  }
}

function init() {
  // if (process.env.VUE_APP_ENV !== 'prod') return
  // 获取user/token信息
  try {
    const employeeNo = store.state.user.account
    const tokens = store.getters['user/tokens']
    const config = {
      employeeNo,
      token: tokens.token,
      rtoken: tokens.rtoken,
      lang: getLang(),
    }
    initTinaSdk(config)
  } catch (e) {
    console.error('初始化tina失败：', e)
  }
}

function getLang() {
  return localStorage.getItem('lang').toLowerCase()
}

// 开始
window.$(document).ready(function () {
  // 添加script标签
  let script = document.createElement('script')
  script.src =
    'https://pfsafecdn.transsion.com/service-pf-cdn-file-center/v2/origin/download/dHJhbnNzaW9uL3VwbG9hZC9maWxl/transsioner-tina-plugin.js?t=1745734108916'
  document.getElementsByTagName('body')[0].appendChild(script)

  setTimeout(() => {
    init()

    const tina = getTinaElement()

    if (!tina) return

    // 设置初始位置
    const initialRect = tina.getBoundingClientRect()
    store.commit('tina/UPDATE_POSITION', {
      right: window.innerWidth - initialRect.right,
      bottom: window.innerHeight - initialRect.bottom,
    })

    tina.addEventListener('dragstart', (e) => {
      console.log('dragstart', e)
    })

    tina.addEventListener('dragend', () => {
      const rect = tina.getBoundingClientRect()
      store.commit('tina/UPDATE_POSITION', {
        right: window.innerWidth - rect.right,
        bottom: window.innerHeight - rect.bottom,
      })
    })
  }, 5000)
})
